import React, { useState } from "react";
import { Label } from "../UI/Form/label";
import { Input } from "../UI/Form/input";
import { cn } from "../../Lib/utils";
import { motion, AnimatePresence } from "framer-motion";
import { Textarea } from "../UI/Form/textarea";
import { Button } from "../UI/Stateful-Button";
const OrderForm = () => {
  const [user, setuser] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    service: "",
    quantity: "",
    addmessage: "",
  });
  const [selectedFile, setselectedFile] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const [formErrors, setformErrors] = useState({});
  const Changeinput = (e) => {
    const { name, value } = e.target;
    setuser((prev) => ({ ...prev, [name]: value }));
    setformErrors((prev) => ({ ...prev, [name]: "" }));
  };
  const [toast, setToast] = useState(false);
  const [errtoast, setErrToast] = useState(false);

  const validateForm = () => {
    const errors = {};

    if (!user.firstName.trim()) {
      errors.firstName = "გთხოვთ შეიყვანოთ სახელი.";
    }

    if (!user.lastName.trim()) {
      errors.lastName = "გთხოვთ შეიყვანოთ თქვენი გვარი";
    }

    if (!user.email.trim()) {
      errors.email = "შეიყვანეთ ემაილი";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(user.email)) {
      errors.email = "ემაილი არასწორია!";
    }
    if (!user.phone.trim()) {
      errors.phone = "გთხოვთ შეიყვანოთ მოქმედი ნომერი";
    }
    if (!user.service.trim()) {
      errors.service = "აირჩიეთ ჩვენი სერვისიდან ერთ-ერთი.";
    }
    if (!user.quantity.trim()) {
      errors.quantity = "გთხოვთ შეავსოთ პროდუქტის რაოდენობა";
    }

    setformErrors(errors);
    return Object.keys(errors).length === 0;
  };
  const [isUploadOpen, setIsUploadOpen] = useState(false);
  const convertToBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    setIsLoading(true);

    let fileBase64 = "";

    if (selectedFile) {
      fileBase64 = await convertToBase64(selectedFile);
    }

    const OrderData = {
      firstName: user.firstName,
      lastName: user.lastName,
      email: user.email,
      phone: user.phone,
      service: user.service,
      quantity: user.quantity,
      message: user.addmessage,
      file: fileBase64,
    };

    try {
      await fetch("/api/startorder", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ OrderData }),
      });
      setToast(true);
      setTimeout(() => {
        setToast(false);
      }, 4000);
      setuser({
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        service: "",
        quantity: "",
        addmessage: "",
      });
      setselectedFile("");
    } catch (error) {
      console.error("Email error:", error);
      setErrToast(true);
      setTimeout(() => {
        setErrToast(false);
      }, 4000);
    }
    setIsLoading(false);
  };
  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   if (!validateForm()) return;
  //   const templateParams = {
  //     firstName: user.firstName,
  //     lastName: user.lastName,
  //     email: user.email,
  //     phone: user.phone,
  //     service: user.service,
  //     quantity: user.quantity,
  //     message: user.addmessage,
  //   };
  //   try {
  //     await emailjs.send(
  //       "service_str66ib",
  //       "template_loy0cus",
  //       templateParams,
  //       "LXSkZ2wdpNYn9gY7q",
  //     );

  //     alert("Email sent successfully!");
  //   } catch (error) {
  //     console.error("Email error:", error);
  //   }
  // };
  return (
    <div className="shadow-input relative  rounded-md border bg-[#cccccc86] p-3 ssm:p-6 shadow-sm ssxx:w-[375px] ssmm:w-[405px] ssm:w-[475px] sfm:w-[530px] smm:w-[620px] sm:w-[680px] mmd:w-[500px]  lg:w-[550px] xl:w-[650px]  cxl:w-[750px] max-w-3xl  md:p-8 border-white/10t text-black  ">
      <h2 className=" text-2xl ssmm:text-3xl cxxl:text-4xl font-ArialGeo text-center font-bold ">
        შეუკვეთე ონლაინ
      </h2>

      <form
        className="my-8     w-full flex flex-col gap-5"
        onSubmit={handleSubmit}
      >
        <div className="mb-4 flex flex-col space-y-2 md:flex-row md:space-y-0 md:space-x-2">
          <LabelInputContainer>
            <Label htmlFor="firstName">სახელი</Label>

            <Input
              type="text"
              name="firstName"
              placeholder="Niki"
              value={user.firstName}
              onChange={Changeinput}
              className={`bg-white text-zinc-800 font-satosIT font-semibold ${
                formErrors.firstName ? "border-2 border-red-500" : ""
              }`}
            />
            {formErrors.firstName && (
              <p className="text-black animate-bounce font-ArialGeo font-bold text-[12px] ssm:text-sm mt-1">
                {formErrors.firstName}
              </p>
            )}
          </LabelInputContainer>
          <LabelInputContainer>
            <Label htmlFor="lastName">გვარი</Label>
            <Input
              type="text"
              name="lastName"
              placeholder="Doe"
              value={user.lastName}
              onChange={Changeinput}
              className={`bg-white text-zinc-800 font-satosIT font-semibold ${
                formErrors.lastName ? "border-2 text-red-900 font-bold" : ""
              }`}
            />
            {formErrors.lastName && (
              <p className="text-black animate-bounce font-ArialGeo font-bold text-[12px] ssm:text-sm mt-1">
                {formErrors.lastName}
              </p>
            )}
          </LabelInputContainer>
        </div>
        <LabelInputContainer className="mb-4">
          <Label htmlFor="email">ელფოსტა</Label>
          <Input
            type="email"
            name="email"
            placeholder="projectmayhem@fc.com"
            value={user.email}
            onChange={Changeinput}
            className={`bg-white text-zinc-800 font-satosIT font-semibold ${
              formErrors.email ? "border-2 border-red-500" : ""
            }`}
          />
          {formErrors.email && (
            <p className="text-black animate-bounce font-ArialGeo font-bold text-[12px] ssm:text-sm mt-1">
              {formErrors.email}
            </p>
          )}
        </LabelInputContainer>
        <LabelInputContainer className="mb-4">
          <Label htmlFor="phone">საკოტანქტო</Label>
          <Input
            type="phone"
            name="phone"
            placeholder="5** ** ** **"
            value={user.phone}
            onChange={Changeinput}
            className={`bg-white text-zinc-800 font-satosIT font-semibold ${
              formErrors.phone ? "border-2 border-red-500" : ""
            }`}
          />
          {formErrors.phone && (
            <p className="text-black animate-bounce font-ArialGeo font-bold text-[12px] ssm:text-sm mt-1">
              {formErrors.phone}
            </p>
          )}
        </LabelInputContainer>

        <div className="flex flex-col flex-wrap font-Mtavruli text-sm ssmm:text-md font-bold">
          <label className="relative mb-[5px] flex cursor-pointer overflow-hidden">
            <input
              className="peer absolute left-[-9999px]"
              type="radio"
              name="service"
              value="ბეჭდვა ტანსაცმელზე"
              onChange={Changeinput}
            />
            <span class="flex items-center rounded-[20px] pb-1.5 pl-1.5 pr-[7px] pt-1.5 text-black duration-200 ease-linear before:mr-[7px] before:flex before:h-5 before:w-5 before:shrink-0 before:rounded-full before:border-2 before:border-solid before:border-[#666] before:bg-white before:shadow-[inset_0_0_0_0_0.125em_#666] before:duration-200 before:ease-linear before:content-[''] hover:bg-[#d6d6d6] peer-checked:bg-[#333] peer-checked:text-white peer-checked:before:shadow-[inset_0_0_0_4px_#666]">
              ბეჭდვა ტანსაცმელზე
            </span>
          </label>
          {/* <label class="relative mb-[5px] flex cursor-pointer overflow-hidden">
            <input
              class="peer absolute left-[-9999px]"
              type="radio"
              name="service"
              value="პოსტერის ბეჭდვა"
              onChange={Changeinput}
            />
            <span class="flex items-center rounded-[20px] pb-1.5 pl-1.5 pr-[7px] pt-1.5 text-black duration-200 ease-linear before:mr-[7px] before:flex before:h-5 before:w-5 before:shrink-0 before:rounded-full before:border-2 before:border-solid before:border-[#666] before:bg-white before:shadow-[inset_0_0_0_0_0.125em_#666] before:duration-200 before:ease-linear before:content-[''] hover:bg-[#d6d6d6] peer-checked:bg-[#333] peer-checked:text-white peer-checked:before:shadow-[inset_0_0_0_4px_#666]">
              პოსტერის ბეჭდვა
            </span>
          </label> */}
          <label className="relative mb-[5px] flex cursor-pointer overflow-hidden">
            <input
              className="peer absolute left-[-9999px]"
              type="radio"
              name="service"
              value="გრაფიკული დიზაინი"
              onChange={Changeinput}
            />
            <span class="flex items-center rounded-[20px] pb-1.5 pl-1.5 pr-[7px] pt-1.5 text-black duration-200 ease-linear before:mr-[7px] before:flex before:h-5 before:w-5 before:shrink-0 before:rounded-full before:border-2 before:border-solid before:border-[#666] before:bg-white before:shadow-[inset_0_0_0_0_0.125em_#666] before:duration-200 before:ease-linear before:content-[''] hover:bg-[#d6d6d6] peer-checked:bg-[#333] peer-checked:text-white peer-checked:before:shadow-[inset_0_0_0_4px_#666]">
              გრაფიკული დიზაინი
            </span>
          </label>
          {formErrors.service && (
            <p className="text-black animate-bounce font-ArialGeo font-bold text-[12px] ssm:text-sm mt-1">
              {formErrors.service}
            </p>
          )}
        </div>
        <LabelInputContainer className="mb-4">
          <Label htmlFor="quantity">აირჩიე პროდუქტის რაოდენობა</Label>
          <Input
            type="quantity"
            name="quantity"
            placeholder="5xx"
            value={user.quantity}
            onChange={Changeinput}
            className={`bg-white text-zinc-800 font-satosIT font-semibold ${
              formErrors.quantity ? "border-2 border-red-500" : ""
            }`}
          />
          {formErrors.quantity && (
            <p className="text-black animate-bounce font-ArialGeo font-bold text-[12px] ssm:text-sm mt-1">
              {formErrors.quantity}
            </p>
          )}
        </LabelInputContainer>
        <div className="flex flex-col gap-2">
          <Label>გაქვთ უკვე დიზაინი?</Label>
          <input
            type="file"
            accept="image/*"
            onChange={(e) => setselectedFile(e.target.files?.[0] || null)}
            className="
      w-full
      rounded-lg
      border
      border-zinc-700
      bg-zinc-900
      text-zinc-300

      file:mr-4
      file:rounded-md
      file:border-0
      file:bg-zinc-800
      file:px-4
      file:py-2
      file:text-white
      hover:file:bg-zinc-700
    "
          />
        </div>
        <div className="flex flex-col gap-2 relative top-2">
          <Label>დამატებითი კომენტარი</Label>
          <Textarea
            name="addmessage"
            value={user.addmessage}
            onChange={Changeinput}
            placeholder="Message"
            className="min-h-[120px] rounded-3xl"
          />
        </div>

        {/* <button
          type="submit"
          onClick={() => console.log(user)}
          class=" text-lg ssm:text-xl w-32 ssm:w-40 h-10 ssm:h-12 font-Mtavruli  flexitems-center justify-center  rounded bg-black text-white relative overflow-hidden group z-10 hover:text-white duration-1000"
        >
          <span className="absolute bg-emerald-600 w-44 h-36 rounded-full group-hover:scale-100 scale-0 -z-10 -left-2 -top-10 group-hover:duration-500 duration-700 origin-center transform transition-all"></span>
          <span className="absolute bg-emerald-800 w-44 h-36 -left-2 -top-10 rounded-full group-hover:scale-100 scale-0 -z-10 group-hover:duration-700 duration-500 origin-center transform transition-all"></span>
          გაგზავნა
          <BottomGradient />
        </button> */}
        <button
          type="submit"
          className="flex  cursor-target   items-center justify-center"
        >
          <Button isLoading={isLoading}>
            გაგზავნა
            <BottomGradient />
          </Button>
        </button>
      </form>
      <AnimatePresence>
        {toast && (
          <motion.div
            initial={{ opacity: 0, y: 50, scale: 0.95 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: -30, scale: 0.95 }}
            transition={{ duration: 0.45, ease: "easeOut" }}
            className="fixed bottom-6 right-3 xsxm:right-6 w-full max-w-xs space-y-3 z-[99]"
          >
            <div className="flex items-start gap-3 p-4 bg-white  border border-gray-200 rounded-md shadow-lg">
              <div className="text-green-500">✔</div>

              <div className="flex-1">
                <p className="text-sm font-medium text-gray-800">
                  წარმატებით გაიგზავნა!
                </p>
                <p className="mt-1 text-xs text-gray-500">
                  ჩვენ მალე დაგიკავშირდებით.
                </p>
              </div>

              <button
                onClick={() => setErrToast(false)}
                className="text-gray-400 hover:text-gray-600"
              >
                ✕
              </button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
      <AnimatePresence>
        {errtoast && (
          <motion.div
            initial={{ opacity: 0, y: 50, scale: 0.95 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: -30, scale: 0.95 }}
            transition={{ duration: 0.45, ease: "easeOut" }}
            className="fixed bottom-6 right-3 xsxm:right-6 w-full max-w-xs space-y-3 z-[99]"
          >
            <div className="flex items-start gap-3 p-4 bg-white  border border-gray-200 rounded-md shadow-lg">
              <div className="text-red-500">✕</div>

              <div className="flex-1">
                <p className="text-sm font-medium text-gray-800">
                  კავშირი შეწყვეტილია!
                </p>
                <p className="mt-1 text-xs text-gray-500">
                  სცადეთ თავიდან ან მოგვწერეთ პირადში.
                </p>
              </div>

              <button
                onClick={() => setErrToast(false)}
                className="text-gray-400 hover:text-gray-600"
              >
                ✕
              </button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default OrderForm;
const BottomGradient = () => {
  return (
    <>
      <span className="absolute inset-x-0 -bottom-px block h-px w-full bg-gradient-to-r from-transparent via-orange-800 to-transparent opacity-0 transition duration-500 group-hover/btn:opacity-100" />
      <span className="absolute inset-x-10 -bottom-px mx-auto block h-px w-1/2 bg-gradient-to-r from-transparent via-red-500 to-transparent opacity-0 blur-sm transition duration-500 group-hover/btn:opacity-100" />
    </>
  );
};

const LabelInputContainer = ({ children, className }) => {
  return (
    <div className={cn("flex w-full flex-col space-y-2", className)}>
      {children}
    </div>
  );
};
